<template>
  <div class="container bg-white mx-auto p-0" v-if="pageData">
    <div class="grid md:grid-cols-2 gap-12 herobanner h-5/6">
      <div
        class="mx-16 md:ml-12 md:mr-0 bg-white rounded-t-3xl mt-48 md:mt-16 p-4 md:py-8 md:px-8"
      >
        <div class="grid lg:grid-cols-2 gap-4 items-center">
          <div>
            <p class="text-sm"><NuxtLink to="/">Home</NuxtLink> / About Us</p>
            <h1>About us</h1>
            <p class="text-sm" v-html="pageData.intro_text"></p>
          </div>
          <div
            class="hidden lg:block"
            v-if="pageData.intro_image && pageData.intro_image.url"
          >
            <img
              loading="lazy"
              :src="imageLocation + pageData.intro_image.url"
              :alt="pageData.intro_image.alt"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="hero-bottom-one">
      <div class="white curveTopRight"></div>
    </div>
    <div class="container mx-auto">
      <h2 class="text-center" v-text="pageData.section_1_title"></h2>
      <div class="grid md:grid-cols-3 gap-4 mx-1 md:mx-auto">
        <div class="md:mx-auto text-center">
          <img
            loading="lazy"
            :src="imageLocation + pageData.section_1_block_1_image.url"
            :alt="pageData.section_1_block_1_image.alt"
            class="rounded-3xl mt-6 md:mx-auto"
            v-if="
              pageData.section_1_block_1_image &&
              pageData.section_1_block_1_image.url
            "
          />
          <h2
            class="text-green-600 my-6"
            v-text="pageData.section_1_block_1_title"
          ></h2>
          <p class="md:px-12" v-html="pageData.section_1_block_1_text"></p>
        </div>
        <div class="md:mx-auto text-center">
          <img
            loading="lazy"
            :src="imageLocation + pageData.section_1_block_2_image.url"
            :alt="pageData.section_1_block_2_image.alt"
            class="rounded-3xl mt-6 md:mx-auto"
            v-if="
              pageData.section_1_block_2_image &&
              pageData.section_1_block_2_image.url
            "
          />
          <h2
            class="text-green-600 my-6"
            v-text="pageData.section_1_block_2_title"
          ></h2>
          <p class="md:px-12" v-html="pageData.section_1_block_2_text"></p>
        </div>
        <div class="md:mx-auto text-center">
          <img
            loading="lazy"
            :src="imageLocation + pageData.section_1_block_3_image.url"
            :alt="pageData.section_1_block_3_image.alt"
            class="rounded-3xl mt-6 md:mx-auto"
            v-if="
              pageData.section_1_block_3_image &&
              pageData.section_1_block_3_image.url
            "
          />
          <h2
            class="text-green-600 my-6"
            v-text="pageData.section_1_block_3_title"
          ></h2>
          <p class="md:px-12" v-html="pageData.section_1_block_3_text"></p>
        </div>
      </div>
    </div>
    <Curves background="EEF1F4" foreground="fff" location="bottomLeft" />
    <Curves background="fff" foreground="EEF1F4" location="topRight" />
    <div class="bg-gray-100 container mx-auto">
      <h1
        class="text-center lg:col-span-2 mb-4 mt-0"
        v-text="pageData.section_2_title"
      ></h1>
      <p
        class="text-center lg:col-span-2 mx-4 lg:mx-40 mb-10"
        v-text="pageData.section_2_text"
      ></p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
        <div class="whyimg mx-auto rounded-3xl" :style="whyImg1">
          <div
            class="bg-blue-300 bg-opacity-50 text-center rounded-b-3xl textoverlay"
          >
            <div class="text text-white md:mx-10">
              <h2 class="py-3" v-text="pageData.section_2_block_1_title"></h2>
              <p
                class="md:mb-4 p-1 md:p-0"
                v-html="pageData.section_2_block_1_text"
              ></p>
            </div>
          </div>
        </div>
        <div class="whyimg mx-auto rounded-3xl" :style="whyImg2">
          <div
            class="bg-blue-300 bg-opacity-50 text-center rounded-b-3xl textoverlay"
          >
            <div class="text text-white md:mx-10">
              <h2 class="py-3" v-text="pageData.section_2_block_2_title"></h2>
              <p
                class="md:mb-4 p-1 md:p-0"
                v-html="pageData.section_2_block_2_text"
              ></p>
            </div>
          </div>
        </div>
        <div class="whyimg mx-auto rounded-3xl" :style="whyImg3">
          <div
            class="bg-blue-300 bg-opacity-50 text-center rounded-b-3xl textoverlay"
          >
            <div class="text text-white md:mx-10">
              <h2 class="py-3" v-text="pageData.section_2_block_3_title"></h2>
              <p
                class="md:mb-4 p-1 md:p-0"
                v-html="pageData.section_2_block_3_text"
              ></p>
            </div>
          </div>
        </div>
        <div class="whyimg mx-auto rounded-3xl" :style="whyImg4">
          <div
            class="bg-blue-300 bg-opacity-50 text-center rounded-b-3xl textoverlay"
          >
            <div class="text text-white md:mx-10">
              <h2 class="py-3" v-text="pageData.section_2_block_4_title"></h2>
              <p
                class="md:mb-4 p-1 md:p-0"
                v-html="pageData.section_2_block_4_text"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Curves background="fff" foreground="EEF1F4" location="bottomRight" />
    <Curves background="EEF1F4" foreground="fff" location="topLeft" />
    <h2 class="text-center" v-text="pageData.section_3_title"></h2>
    <p
      class="text-center mx-12 lg:mx-40 mb-16"
      v-html="pageData.section_3_text"
    ></p>
    <div class="grid lg:grid-cols-4 gap-4 px-4 md:px-16">
      <div class="bg-gray-50 mx-auto text-center rounded-3xl">
        <img
          loading="lazy"
          :src="imageLocation + pageData.section_3_block_1_image.url"
          :alt="pageData.section_3_block_1_image.alt"
          class="my-8 mx-auto"
          v-if="
            pageData.section_3_block_1_image &&
            pageData.section_3_block_1_image.url
          "
        />
        <h2 class="my-4" v-text="pageData.section_3_block_1_title"></h2>
        <p class="px-8 mb-16" v-text="pageData.section_3_block_1_text"></p>
      </div>
      <div class="bg-gray-50 mx-auto text-center rounded-3xl">
        <img
          loading="lazy"
          :src="imageLocation + pageData.section_3_block_2_image.url"
          :alt="pageData.section_3_block_2_image.alt"
          class="my-8 mx-auto"
          v-if="
            pageData.section_3_block_2_image &&
            pageData.section_3_block_2_image.url
          "
        />
        <h2 class="my-4" v-text="pageData.section_3_block_2_title"></h2>
        <p class="px-8 mb-16" v-text="pageData.section_3_block_2_text"></p>
      </div>
      <div class="bg-gray-50 mx-auto text-center rounded-3xl">
        <img
          loading="lazy"
          :src="imageLocation + pageData.section_3_block_3_image.url"
          :alt="pageData.section_3_block_3_image.alt"
          class="my-8 mx-auto"
          v-if="
            pageData.section_3_block_3_image &&
            pageData.section_3_block_3_image.url
          "
        />
        <h2 class="my-4" v-text="pageData.section_3_block_3_title"></h2>
        <p class="px-8 mb-16" v-text="pageData.section_3_block_3_text"></p>
      </div>
      <div class="bg-gray-50 mx-auto text-center rounded-3xl">
        <img
          loading="lazy"
          :src="imageLocation + pageData.section_3_block_4_image.url"
          :alt="pageData.section_3_block_4_image.alt"
          class="my-8 mx-auto"
          v-if="
            pageData.section_3_block_4_image &&
            pageData.section_3_block_4_image.url
          "
        />
        <h2 class="my-4" v-text="pageData.section_3_block_4_title"></h2>
        <p class="px-8 mb-16" v-text="pageData.section_3_block_4_text"></p>
      </div>
    </div>

    <Curves background="EEF1F4" foreground="fff" location="bottomRight" />
    <Curves background="fff" foreground="EEF1F4" location="topLeft" />
    <div class="grid lg:grid-cols-2 gap-4 bg-gray-100">
      <div class="mx-8 md:mx-16 pb-6">
        <h1 class="" v-text="pageData.approach_title"></h1>
        <p class="text-sm mb-12" v-html="pageData.approach_text"></p>
        <NuxtLink to="/about-us/our-green-approach/">
          <button class="w-8/12 py-2"><span>Learn More</span></button>
        </NuxtLink>
      </div>
      <div
        class="bg-white rounded-3xl mx-2 md:mx-16 grid grid-cols-2 gap-4 items-center"
      >
        <img
          loading="lazy"
          :src="imageLocation + pageData.approach_image_1.url"
          :alt="pageData.approach_image_1.alt"
          class="m-6 col-span-2 mx-auto"
          v-if="pageData.approach_image_1 && pageData.approach_image_1.url"
        />
        <img
          loading="lazy"
          :src="imageLocation + pageData.approach_image_2.url"
          :alt="pageData.approach_image_2.alt"
          class="m-6 mx-auto mt-0"
          v-if="pageData.approach_image_2 && pageData.approach_image_2.url"
        />
        <img
          loading="lazy"
          :src="imageLocation + pageData.approach_image_3.url"
          :alt="pageData.approach_image_3.alt"
          class="m-6 mx-auto mt-0"
          v-if="pageData.approach_image_3 && pageData.approach_image_3.url"
        />
        <img
          loading="lazy"
          :src="imageLocation + pageData.approach_image_4.url"
          :alt="pageData.approach_image_4.alt"
          class="m-6 mx-auto mt-0"
          v-if="pageData.approach_image_4 && pageData.approach_image_4.url"
        />
      </div>
    </div>
    <Curves background="fff" foreground="EEF1F4" location="bottomLeft" />
    <Curves background="EEF1F4" foreground="fff" location="topRight" />
    <div
      class="grid lg:grid-cols-2 gap-4 mx-4 md:mx-16 bg-gray-100 rounded-3xl"
    >
      <div>
        <img
          loading="lazy"
          :src="imageLocation + pageData.contact_us_image.url"
          :alt="pageData.contact_us_image.alt"
          class="rounded-3xl"
          v-if="pageData.contact_us_image && pageData.contact_us_image.url"
        />
      </div>
      <div class="text-center px-4 md:px-24 pb-8 self-center">
        <h2 class="text-lg" v-text="pageData.contact_us_title"></h2>
        <hr class="hidden md:block" />
        <p v-text="pageData.contact_us_text"></p>
        <NuxtLink to="/about-us/contact-spring-green/">
          <button class="w-8/12 py-2 mb-2"><span>Contact Us</span></button>
        </NuxtLink>
      </div>
    </div>
    <Curves background="EEF1F4" foreground="fff" location="bottomLeft" />
    <Curves background="fff" foreground="EEF1F4" location="topRight" />
    <Faq
      :prefetchedFaqs="ucmsFaqList"
      :disableSchema="true"
      greybg="Y"
      headerText="Frequently Asked Questions"
    />
    <Curves background="fff" foreground="EEF1F4" location="bottomRight" />
    <Curves background="EEF1F4" foreground="fff" location="topLeft" />
  </div>
</template>

<script setup lang="ts">
import { useSeoHead, buildFaqSchema, buildAboutPageSchema } from "~/composables/useSeo";

const { $sg, $companies } = useNuxtApp();
const runtimeConfig = useRuntimeConfig();
const imageLocation = runtimeConfig.public?.sgCmsImage || "";
const frontEndUrl = runtimeConfig.public?.frontEndUrl || "https://www.spring-green.com";

// Fetch page data and UCMS FAQs for SSR
const { data: pageData } = await useAsyncData("about-us-page", () =>
  $sg.getOctoberData("pages/aboutus")
);

// Fetch UCMS FAQ data (plain-text answers, richer dataset) for both schema and component display
const { data: ucmsFaqData } = await useAsyncData("about-us-ucms-faqs", () =>
  $companies.getUCMSAdminFAQ({
    categoryId: 0,
    sqldbid: 0,
    uP_ServiceDefinition_IDs: [],
  })
);

const { $metadata } = useNuxtApp();
const { data: orgData } = await useAsyncData("about-us-org", () =>
  $metadata?.getOrganizationStructuredData?.() ?? Promise.resolve(null)
);

// Pre-fetched UCMS FAQ list for the <Faq> component (avoids redundant client-side fetch)
const ucmsFaqList = computed(() => {
  const data = ucmsFaqData.value;
  if (!data || data.error) return [];
  return Array.isArray(data) ? data : [];
});

// Build FAQ structured data from UCMS source (plain-text answers)
const faqSD = computed(() => {
  if (!ucmsFaqList.value.length) return null;
  const faqItems = ucmsFaqList.value
    .filter((item: any) => item.Question && item.Answer)
    .map((item: any) => ({
      question: item.Question,
      answer: item.Answer,
    }));
  if (faqItems.length === 0) return null;
  return buildFaqSchema({ faqs: faqItems });
});

// Build AboutPage structured data
const aboutPageSD = computed(() => {
  return buildAboutPageSchema({
    name: "About Spring-Green Lawn Care",
    description:
      "Learn about Spring-Green's history, values, and professional lawn, pest, and tree care services since 1977.",
    url: `${frontEndUrl}/about-us`,
    websiteId: `${frontEndUrl}/#website`,
    organizationId: `${frontEndUrl}/#organization`,
    breadcrumbId: `${frontEndUrl}/about-us/#breadcrumb`,
  });
});

// Apply SEO with watchEffect for reactivity
watchEffect(() => {
  const allSD = [aboutPageSD.value, faqSD.value].filter(Boolean);
  useSeoHead({
    title: pageData.value?.seo_title || "About Us | Spring-Green",
    description:
      pageData.value?.meta_description ||
      "For more than 30 years, Spring-Green has been providing professional lawn care services. Visit our site to learn more about our dedication to quality.",
    openGraph: {
      title: pageData.value?.seo_title || "About Us | Spring-Green",
      description: pageData.value?.meta_description,
      url: `${frontEndUrl}/about-us/`,
      type: "website",
    },
    structuredData: allSD,
    orgData: orgData.value,
    breadcrumbs: [
      { name: "Home", url: `${frontEndUrl}/` },
      { name: "About Us", url: `${frontEndUrl}/about-us/` },
    ],
    breadcrumbId: `${frontEndUrl}/about-us/#breadcrumb`,
  });
});

const whyImg1 = computed(() => ({
  "background-image": `url('${imageLocation}${
    pageData.value?.section_2_block_1_image?.url || ""
  }')`,
}));

const whyImg2 = computed(() => ({
  "background-image": `url('${imageLocation}${
    pageData.value?.section_2_block_2_image?.url || ""
  }')`,
}));

const whyImg3 = computed(() => ({
  "background-image": `url('${imageLocation}${
    pageData.value?.section_2_block_3_image?.url || ""
  }')`,
}));

const whyImg4 = computed(() => ({
  "background-image": `url('${imageLocation}${
    pageData.value?.section_2_block_4_image?.url || ""
  }')`,
}));
</script>


<style scoped>
.herobanner {
  background: url("~/assets/images/hero-about.jpg") no-repeat right top;
  height: 441px;
}

.hero-bottom-one {
  background: url("~/assets/images/hero-about.jpg") no-repeat right -441px;
}

.curveTopRight {
  width: 100%;
  background: #fff;
  height: 70px;
  background-position: left bottom;
  border-top-right-radius: 70px;
}

.bg-gray-100 {
  background-color: #eef1f4;
}

.whyimg {
  background-size: cover; /* Resize the background image to cover the entire container */
  overflow: hidden;
}

.whysgone {
  background-image: url("~/assets/images/whysgone.png");
  background-size: cover; /* Resize the background image to cover the entire container */
  overflow: hidden;
}

.whysgtwo {
  background-image: url("~/assets/images/whysgtwo.png");
  background-size: cover; /* Resize the background image to cover the entire container */
  overflow: hidden;
}

.whysgthree {
  background-image: url("~/assets/images/whysgthree.png");
  background-size: cover; /* Resize the background image to cover the entire container */
  overflow: hidden;
}

.whysgfour {
  background-image: url("~/assets/images/whysgfour.png");
  background-size: cover; /* Resize the background image to cover the entire container */
  overflow: hidden;
}

.bg-blue-300 {
  background-color: #517185;
  opacity: 0.9;
}

.textoverlay {
  margin-top: 200px;
  height: 100%;
}

.text h2,
.text p {
  color: white;
}

hr {
  margin-top: 1.5rem;
  margin-bottom: 2rem;
}

@media (max-width: 430px) {
  .herobanner {
    background-image: url("~/assets/images/hero-about.jpg");
    background-size: cover; /* Resize the background image to cover the entire container */
    background-position: bottom; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
  }
}
</style>
